export default {
    impresionDialog: true,
    trabajosPorImprimir: [],
    trabajoQueSeEstanTratando: [],
    logosCaja: [],
    pedidoOcupado: null
}